// components
import GridPageAbstract from '../abstract/GridPageAbstract';

export default class ReportTypesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'reportTypes';
        this.Server = this.props.context.getState().server.reportTypes;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
                {
                    id: 'templateType',
                    label: 'reportTemplateType',
                    cell: 'Items',
                    items: ['simple', 'laboratory', 'client'],
                    alignRight: false,
                    displayGrid: true
                },
                {
                    id: 'templateFile',
                    label: 'reportTemplate',
                    alignRight: false,
                    cell: 'Upload',
                    displayGrid: false
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
